<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import moment from "moment";
import exportFromJSON from "export-from-json";
import {getBaseUrl} from "@/helpers/baseUrl";
import ExcelJS from "exceljs";
import { saveAs } from 'file-saver-es';
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";

export default {
  page: {
    title: "Categorias",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, DropZone },
  setup() {
    let dropzoneFile = ref("");
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
    };
    const onDrop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    return { dropzoneFile, selectedFile, onDrop };
  },
  data() {
    return {
      title: 'Categorias',
      items: [
        { text: 'Cadastros', href: '/' },
        { text: 'Categorias', active: true },
      ],
      errosValid: null,
      loadingList: true,
      categoriasList: [],
      pesqTextFilter: '',
      statusFilter: 'T',
      showImportModal: false,
      importLoading: false,
      expanded: new Set(),
      isTreeMode: true,
    }
  },
  computed: {
    displayList() {
      if (this.pesqTextFilter || !this.isTreeMode) {
        return this.categoriasList.map(cat => ({ ...cat, depth: 0, hasChildren: false }));
      }

      const tree = this.buildTree(this.categoriasList);
      const flattened = [];

      const flatten = (nodes, depth = 0) => {
        nodes.forEach(node => {
          const hasChildren = node.children && node.children.length > 0;
          flattened.push({ ...node, depth, hasChildren, children: undefined });
          
          if (this.expanded.has(node.id) && hasChildren) {
            flatten(node.children, depth + 1);
          }
        });
      };

      flatten(tree);
      return flattened;
    }
  },
  methods: {
    exportExcel() {
      const data = this.categoriasList.map(cat => ({
        'ID': cat.id,
        'Código': cat.codigo,
        'Descrição': cat.descricao,
        'Tipo': cat.tipo === 'EN' ? 'Receita' : 'Despesa',
        'Status': cat.status === 'A' ? 'Ativo' : 'Inativo',
        'Observação': cat.livre1,
        'ID Categoria Raiz': cat.parent_id || '',
        'Código Categoria Raiz': cat.parent_codigo || '',
        'Descrição Categoria Raiz': cat.parent_descricao || '',
        'Data Criação': moment(cat.created_at).format("DD/MM/YYYY HH:mm")
      }));
      const fileName = "categorias_export";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList() {
      this.loadingList = true;
      api.get(`${getBaseUrl()}api/categorias`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios');
        console.log(res.data);
        this.categoriasList = res.data[0] || [];
        this.title = `(${this.categoriasList.length}) Categorias`;
        this.loadingList = false;
      }).catch(() => {
        this.loadingList = false;
        Swal.fire("Erro", "Não foi possível carregar as categorias.", "error");
      });
    },

    deletar(dataID) {
      Swal.fire({
        title: "Tem certeza?",
        text: "Esta operação é irreversível!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loadingList = true;
          api.delete(`${getBaseUrl()}api/categoria`, {
            params: { 'iddata': dataID }
          }).then(() => {
            this.atualizaDataList();
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Excluído com sucesso!",
              showConfirmButton: false,
              timer: 1500
            });
          }).catch(() => {
            this.loadingList = false;
            Swal.fire("Erro", "Erro ao excluir o registro.", "error");
          });
        }
      });
    },

    nomeStatus(status) {
      return status === 'A' ? 'Ativo' : 'Inativo';
    },

    nomeStatusTipo(tipo) {
      return tipo === 'EN' ? 'Receita' : 'Despesa';
    },

    formatDateTime(value) {
      if (!value) return "-";
      return moment(value).format("DD/MM/YYYY HH:mm");
    },
    
    editar(id) {
      this.$router.push(`/categoria/editar/${id}`);
    },

    async downloadModelo() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Categorias');

      worksheet.columns = [
        { header: 'Descrição', key: 'descricao', width: 30 },
        { header: 'Código', key: 'codigo', width: 15 },
        { header: 'Tipo (Receita/Despesa)', key: 'tipo', width: 25 },
        { header: 'Observação', key: 'livre1', width: 30 },
        { header: 'Código Categoria Raiz', key: 'parent_code', width: 25 },
      ];

      worksheet.addRow({ descricao: 'Exemplo Receita Raiz', codigo: 'REC01', tipo: 'Receita', livre1: 'Obs opcional', parent_code: '' });
      worksheet.addRow({ descricao: 'Exemplo Subcategoria', codigo: 'SUB01', tipo: 'Receita', livre1: '', parent_code: 'REC01' });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'modelo_importacao_categorias.xlsx');
    },

    handleFileUpload(event) {
      this.dropzoneFile = event.target.files[0];
    },

    async processarImportacao() {
      if (!this.dropzoneFile || !this.dropzoneFile.name) {
        Swal.fire("Atenção", "Por favor, selecione um arquivo primeiro.", "warning");
        return;
      }

      this.importLoading = true;
      const workbook = new ExcelJS.Workbook();
      
      try {
        const reader = new FileReader();
        reader.readAsArrayBuffer(this.dropzoneFile);
        
        reader.onload = async () => {
          const buffer = reader.result;
          await workbook.xlsx.load(buffer);
          const worksheet = workbook.getWorksheet(1);
          const importList = [];

          worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) { // Skip header
              const desc = row.getCell(1).text;
              let tipo = row.getCell(3).text;
              
              // Simple mapping logic
              if (tipo) {
                const tipoStr = tipo.toUpperCase();
                if (tipoStr.includes('DESP') || tipoStr.includes('SA')) tipo = 'SA';
                else if (tipoStr.includes('RECEI') || tipoStr.includes('EN')) tipo = 'EN';
              }

              importList.push({
                descricao: desc,
                codigo: row.getCell(2).text,
                tipo: tipo,
                livre1: row.getCell(4).text,
                parent_code: row.getCell(5).text,
                status: 'A'
              });
            }
          });

          if (importList.length === 0) {
            Swal.fire("Atenção", "Nenhum dado válido encontrado na planilha.", "warning");
            this.importLoading = false;
            return;
          }

          // Send to backend
          api.post(`${getBaseUrl()}api/importlistcateg`, {
            categoriaslist: importList
          }).then((res) => {
            this.importLoading = false;
            const data = res.data;

            if (data.success) {
              this.showImportModal = false;
              this.dropzoneFile = "";
              Swal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: data.message || "Categorias importadas com sucesso!",
                timer: 2500,
                showConfirmButton: false
              });
              this.atualizaDataList();
            } else {
              const isWarning = data.successCount === true;
              const icon = isWarning ? 'warning' : 'error';
              const title = isWarning ? 'Importação Parcial' : 'Erro na Importação';
              
              let errorHtml = `
                <div class="text-start mt-3">
                  <p class="mb-2"><strong>${data.message}</strong></p>
                  <div style="max-height: 300px; overflow-y: auto; border: 1px solid #eee; border-radius: 8px; padding: 10px; background: #fafafa;">
                    <table class="table table-sm font-size-12 mb-0">
                      <thead class="table-light">
                        <tr>
                          <th>Código</th>
                          <th>Descrição</th>
                          <th>Tipo</th>
                          <th>Código Raiz</th>
                          <th style="width: 150px;">Erro</th>
                        </tr>
                      </thead>
                      <tbody>
              `;

              if (data.listErro && data.listErro.length > 0) {
                data.listErro.forEach(err => {
                  errorHtml += `
                    <tr>
                      <td class="text-truncate" style="max-width: 200px;">${err.codigo || 'S/ Código'}</td>
                      <td class="text-truncate" style="max-width: 200px;">${err.descricao || 'S/ Descrição'}</td>
                      <td class="text-truncate" style="max-width: 200px;">${err.tipo || 'S/ Tipo'}</td>
                      <td class="text-truncate" style="max-width: 200px;">${err.parent_code || '-'}</td>
                      <td class="text-danger small">${err.msgerror}</td>
                    </tr>
                  `;
                });
              } else {
                errorHtml += `<tr><td colspan="2" class="text-center text-muted">Nenhum erro detalhado disponível.</td></tr>`;
              }

              errorHtml += `
                      </tbody>
                    </table>
                  </div>
                </div>
              `;

              Swal.fire({
                icon: icon,
                title: title,
                html: errorHtml,
                width: '600px',
                confirmButtonText: 'Fechar',
                confirmButtonColor: '#556ee6'
              });

              if (data.successCount) {
                this.atualizaDataList();
              }
            }
          }).catch((err) => {
            this.importLoading = false;
            Swal.fire("Erro", "Falha na comunicação com o servidor.", "error");
            console.error(err);
          });
        };
      } catch (error) {
        this.importLoading = false;
        Swal.fire("Erro", "Não foi possível ler o arquivo Excel.", "error");
        console.error(error);
      }
    },

    toggleExpand(id) {
      if (this.expanded.has(id)) {
        this.expanded.delete(id);
      } else {
        this.expanded.add(id);
      }
      this.expanded = new Set(this.expanded);
    },

    buildTree(list) {
      const map = {};
      const roots = [];
      list.forEach(item => { map[item.id] = { ...item, children: [] }; });
      list.forEach(item => {
        if (item.parent_id && map[item.parent_id]) {
          map[item.parent_id].children.push(map[item.id]);
        } else {
          roots.push(map[item.id]);
        }
      });
      return roots;
    }
  },
  mounted() {
    console.log('mounted categorias-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg border-0 mb-4 overflow-hidden" style="border-radius: 15px;">
          <div class="card-header bg-white border-0 py-3">
            <div class="row align-items-center">
              <div class="col-lg-8">
                <div class="d-flex flex-wrap gap-3">
                  <div class="search-box position-relative" style="min-width: 250px;">
                    <input
                      type="text"
                      v-model="pesqTextFilter"
                      class="form-control border-light shadow-sm ps-4"
                      placeholder="Pesquisar categoria..."
                      @keyup.enter="atualizaDataList"
                      style="border-radius: 10px; height: 45px; padding-left: 40px;"
                    />
                    <i class="bx bx-search-alt position-absolute" style="left: 15px; top: 14px; color: #adb5bd; font-size: 18px;"></i>
                  </div>

                  <div class="filter-box" style="min-width: 150px;">
                    <select
                      v-model="statusFilter"
                      @change="atualizaDataList"
                      class="form-select border-light shadow-sm"
                      style="border-radius: 10px; height: 45px;"
                    >
                      <option value="T">Todos os Status</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                  </div>

                  <b-button variant="light" class="shadow-sm px-3" style="border-radius: 10px; height: 45px;" @click="exportExcel">
                    <i class="bx bx-export font-size-18 align-middle me-1"></i> Exportar
                  </b-button>

                  <b-button variant="soft-info" class="shadow-sm px-3" style="border-radius: 10px; height: 45px;" @click="showImportModal = true">
                    <i class="bx bx-import font-size-18 align-middle me-1"></i> Importar
                  </b-button>
                </div>
              </div>

              <div class="col-lg-4 text-lg-end mt-3 mt-lg-0">
                <router-link :to="`/categoria/editar/0`" class="btn btn-success btn-lg shadow-sm px-4" style="border-radius: 12px; height: 45px; display: inline-flex; align-items: center;">
                  <i class="mdi mdi-plus-circle-outline font-size-18 me-2"></i> Nova Categoria
                </router-link>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <Loader v-if="loadingList" style="min-height: 400px;" />

            <div v-else-if="categoriasList.length === 0" class="text-center py-5">
              <div class="mb-3">
                <i class="bx bx-folder-open text-muted" style="font-size: 60px;"></i>
              </div>
              <h5 class="text-muted">Nenhuma categoria encontrada</h5>
            </div>

            <div v-else class="table-responsive">
              <table class="table table-hover align-middle table-nowrap mb-0">
                <thead class="bg-light text-uppercase font-size-12" style="background-color: #f8f9fa;">
                  <tr>
                    <th class="ps-4" style="width: 80px;">ID</th>
                    <th>Código</th>
                    <th>Descrição</th>
                    <th>SubCategoria</th>
                    <th class="text-center">Tipo</th>
                    <th class="text-center">Status</th>
                    <th>Criação</th>
                    <th class="text-end pe-4">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="data in displayList" 
                    :key="data.id" 
                    :class="['transition-hover', { 'bg-soft-light': data.depth > 0, 'cursor-pointer': data.hasChildren }]"
                    @click="data.hasChildren ? toggleExpand(data.id) : null"
                  >
                    <td class="ps-4 fw-medium text-primary">#{{ data.id }}</td>
                    <td><span class="badge bg-light text-dark px-2 py-1" style="border-radius: 6px;">{{ data.codigo }}</span></td>
                    <td :style="{ paddingLeft: (data.depth * 30 + 12) + 'px' }">
                      <div class="d-flex align-items-center">
                        <i 
                          v-if="data.hasChildren"
                          :class="['mdi me-2 font-size-18', expanded.has(data.id) ? 'mdi-chevron-down text-primary' : 'mdi-chevron-right text-muted']"
                        ></i>
                        <i v-else-if="isTreeMode && !pesqTextFilter" class="mdi mdi-circle-small me-2 text-light font-size-18"></i>
                        
                        <div>
                          <div :class="['text-dark', data.depth === 0 ? 'fw-bold' : 'fw-medium']">{{ data.descricao }}</div>
                          <small class="text-muted" v-if="data.livre1">{{ data.livre1 }}</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="fw-bold text-dark">{{ data.parent_id ? 'SubCategoria' : 'Categoria Raiz'  }}</div>
                      <small class="text-muted" v-if="data.parent_id">{{ `Raiz ID: ${data.parent_id} | Nome: ${data.parent_descricao}` }}</small>
                    </td>
                    <td class="text-center">
                      <span :class="['badge px-3 py-2', data.tipo === 'EN' ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger']" style="border-radius: 8px; font-weight: 600;">
                        {{ nomeStatusTipo(data.tipo) }}
                      </span>
                    </td>
                    <td class="text-center">
                      <div :class="['d-inline-flex align-items-center', data.status === 'A' ? 'text-success' : 'text-danger']">
                        <i :class="['mdi mdi-circle font-size-10 me-1', data.status === 'A' ? 'text-success' : 'text-danger']"></i>
                        <span class="fw-medium">{{ nomeStatus(data.status) }}</span>
                      </div>
                    </td>
                    <td class="text-muted font-size-13">{{ formatDateTime(data.created_at) }}</td>
                    <td class="text-end pe-4">
                      <div class="d-flex justify-content-end gap-2">
                        <b-button variant="soft-primary" class="btn-sm border-0 shadow-none" v-b-tooltip.hover title="Editar" @click.stop="editar(data.id)" style="width: 35px; height: 35px; padding: 0;">
                          <i class="mdi mdi-pencil font-size-18"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card-footer bg-white border-0 py-3">
            <div class="row align-items-center">
              <div class="col-sm-6 text-muted font-size-13">
                Exibindo {{ categoriasList.length }} resultados
              </div>
              <div class="col-sm-6">
                <ul class="pagination pagination-rounded justify-content-end mb-0">
                  <li class="page-item disabled"><a class="page-link" href="#"><i class="mdi mdi-chevron-left"></i></a></li>
                  <li class="page-item active"><a class="page-link" href="#">1</a></li>
                  <li class="page-item disabled"><a class="page-link" href="#"><i class="mdi mdi-chevron-right"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed-bottom p-3" style="max-width: 400px; z-index: 1050;">
      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger" class="shadow-lg">
        <i class="mdi mdi-alert-circle-outline me-2"></i>
        <strong>{{ erro.titulo }}:</strong> {{ erro.mensagem[0] }}
      </b-alert>
    </div>

    <b-modal
      v-model="showImportModal"
      title="Importar Categorias"
      title-class="text-black font-20 fw-bold"
      body-class="p-0 border-0"
      hide-footer
      centered
      size="lg"
      @hide="dropzoneFile = ''"
    >
      <div class="p-4">
        <div class="text-center mb-4">
          <div class="avatar-lg mx-auto mb-3">
            <div class="avatar-title bg-soft-success rounded-circle text-success h1" style="font-size: 50px;">
              <i class="mdi mdi-microsoft-excel"></i>
            </div>
          </div>
          <h4 class="fw-bold">Importação em Massa</h4>
          <p class="text-muted mx-auto" style="max-width: 400px;">Siga os passos abaixo para atualizar sua base de categorias rapidamente.</p>
        </div>

        <div class="row g-4 mb-4">
          <div class="col-md-5">
            <div class="card h-100 border-0 bg-light shadow-none" style="border-radius: 16px;">
              <div class="card-body p-4 d-flex flex-column">
                <div class="mb-3">
                  <span class="badge bg-primary rounded-pill px-3 mb-2">Passo 1</span>
                  <h5 class="fw-bold mt-2">Baixar Modelo</h5>
                  <p class="small text-muted">Use nossa planilha padrão para evitar erros no processamento.</p>
                </div>
                <b-button variant="info" class="mt-auto shadow-sm w-100 py-2 fw-bold" style="border-radius: 10px;" @click="downloadModelo">
                  <i class="bx bx-download me-2 font-size-18 align-middle"></i> Modelo .xlsx
                </b-button>
              </div>
            </div>
          </div>

          <div class="col-md-7">
            <div class="card h-100 border-0 bg-light shadow-none" style="border-radius: 16px;">
              <div class="card-body p-4">
                <div class="mb-3">
                  <span class="badge bg-success rounded-pill px-3 mb-2">Passo 2</span>
                  <h5 class="fw-bold mt-2">Enviar Arquivo</h5>
                  <p class="small text-muted">Arraste seu arquivo ou clique no campo abaixo.</p>
                </div>
                
                <DropZone @change="selectedFile" @drop.prevent="onDrop" class="mb-2" />
                
                <div v-if="dropzoneFile && dropzoneFile.name" class="mt-2 p-2 bg-white rounded border d-flex align-items-center">
                  <i class="mdi mdi-file-excel-outline text-success font-size-24 me-2"></i>
                  <div class="overflow-hidden">
                    <div class="text-truncate fw-medium">{{ dropzoneFile.name }}</div>
                    <small class="text-muted">{{ (dropzoneFile.size / 1024).toFixed(1) }} KB</small>
                  </div>
                  <button class="btn btn-link text-danger ms-auto p-0" @click="dropzoneFile = ''">
                    <i class="mdi mdi-close"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 p-3 bg-light border-top" style="margin: 0 -1.5rem -1.5rem -1.5rem; border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;">
          <b-button variant="link" class="text-muted fw-bold" @click="showImportModal = false">Cancelar</b-button>
          <b-button :disabled="importLoading || !dropzoneFile || !dropzoneFile.name" variant="success" class="px-5 shadow-sm fw-bold" style="border-radius: 10px;" @click="processarImportacao">
            <span v-if="importLoading">
              <i class="bx bx-loader bx-spin font-size-18 align-middle me-2"></i> Processando...
            </span>
            <span v-else>
              <i class="mdi mdi-check-all me-1 font-size-18 align-middle"></i> Confirmar Importação
            </span>
          </b-button>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style scoped>
.transition-hover {
  transition: all 0.2s ease;
}
.transition-hover:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
}
.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
}
.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.1);
  color: #556ee6;
}
.bg-soft-primary:hover {
  background-color: #556ee6;
  color: #fff;
}
.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
  color: #50a5f1;
}
.bg-soft-info:hover {
  background-color: #50a5f1;
  color: #fff;
}
.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.5);
}
.cursor-pointer {
  cursor: pointer;
}
</style>

